import { render, staticRenderFns } from "./bulkShelvesResults.vue?vue&type=template&id=0763bb28&scoped=true"
import script from "./bulkShelvesResults.vue?vue&type=script&lang=js"
export * from "./bulkShelvesResults.vue?vue&type=script&lang=js"
import style0 from "./bulkShelvesResults.vue?vue&type=style&index=0&id=0763bb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0763bb28",
  null
  
)

export default component.exports